import last from 'lodash/last';

import getLayerIdsFromTiers from './getLayerIdsFromTiers';

export default function getLastLayerIdsFromTiers(tiers) {
    return getLayerIdsFromTiers(tiers, last);
}



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/getLastLayerIdsFromTiers.js